export const GET_IMAGES = 'GET_IMAGES';
export const GET_IMAGES_START = `${GET_IMAGES}_START`;
export const GET_IMAGES_SUCCESS = `${GET_IMAGES}_SUCCESS`;
export const GET_IMAGES_FAIL = `${GET_IMAGES}_FAIL`;

export const DELETE_IMAGE = 'DELETE_IMAGE';
export const DELETE_IMAGE_START = `${DELETE_IMAGE}_START`;
export const DELETE_IMAGE_SUCCESS = `${DELETE_IMAGE}_SUCCESS`;
export const DELETE_IMAGE_FAIL = `${DELETE_IMAGE}_FAIL`;

export const POST_IMAGE = 'POST_IMAGE';
export const POST_IMAGE_START = `${POST_IMAGE}_START`;
export const POST_IMAGE_SUCCESS = `${POST_IMAGE}_SUCCESS`;
export const POST_IMAGE_FAIL = `${POST_IMAGE}_FAIL`;

export const SELECT_IMAGE_ID = 'SELECT_IMAGE_ID';

export function selectImageId(id) {
  return {
    type: SELECT_IMAGE_ID,
    payload: id,
  };
}

export function getImages(imageType) {
  return {
    type: GET_IMAGES,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/images`,
      method: 'get',
      params: {
        imageType,
        limit: 1000,
      },
    },
  };
}

export function uploadImage({ file, imageClass }) {
  return {
    type: POST_IMAGE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/images`,
      method: 'post',
      contentType: 'multipart/form-data',
      params: {
        hasFile: true,
        imageClass,
        file,
      },
    },
  };
}

export function deleteImage(id) {
  return {
    type: DELETE_IMAGE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/images/${id}`,
      method: 'del',
    },
  };
}
